
























import Vue from 'vue';
import { stripWhiteSpace } from 'src/utils/string';
import ModalMixin from '@/components/modal/mixin.vue';

export default Vue.extend({
  filters: {
    stripWhiteSpace,
  },
  mixins: [ModalMixin],
  props: {
    modalId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    thumbnailImageUrl: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
  },
});
